/* file description */

import type { RelationTreeType } from '@/asset/AssetTask/templates/Cascade/type';
import useMetaStore from '@/store/useMetaStore';
import { MetaOfRule } from '@/store/type';
import { ruleMapMatchExec } from '@/store/rulesCalc';
import useValuesStore from '@/store/useValuesStore';

interface GetuseSPFormWithModelSchemaProps {
  schemaList: RelationTreeType;
  metaInfoByRule?: MetaOfRule;
}
export type useSPFormWithModelSchemaReturnType = ReturnType<typeof useSPFormWithModelSchema>;
export const useSPFormWithModelSchema = ({
  schemaList,
  metaInfoByRule,
}: GetuseSPFormWithModelSchemaProps) => {
  const sotreState = useMetaStore((state) => state);
  const { values, setValues, rulesMap } = useValuesStore();
  const { taskId, recordId, utils, taskInfo, pageConfig, pageType, moduleList, moduleTaskField } = sotreState;
  const pageModuleConfig = pageConfig?.pageModuleConfig;

  let resultModule = moduleList.find(
    (item) => item.handle === schemaList?.code,
  );
  if (!resultModule && moduleList.length === 1) {
    resultModule = moduleList[0];
  }
  const {
    name: moduleName,
    handle: moduleHandle,
    namespaceHandle,
  } = resultModule;

  // let columns = resultModule?.fields.filter(f => f.visible !== false);
  let columns = resultModule?.fields.map((field: Record<string, any>) => {
    const f = moduleTaskField[moduleHandle].find((item) => item.field_id === field.fieldID);
    const columsOption = {
      dataIndex: field.name,
      fieldID: field.fieldID,
      isRequired: !!f?.required,
    };
    if (f?.field_from === 'quote') {
      return {
        ...columsOption,
        isDisabled: true,
      };
    }
    return {
      ...columsOption,
    };
  });

  // 基于规则生成的meta信息处理colums
  const ruleFields = metaInfoByRule?.[schemaList?.code]?.fields || [];
  ruleFields.forEach((ruleField) => {
    const column = columns.find((col: any) => col.dataIndex === ruleField.dataIndex);
    if (column) {
      Object.assign(column, ruleField);
    }
  });
  columns = columns.filter((col: any) => col.visible !== false);

  if (pageModuleConfig?.[moduleHandle]) {
    const mainModuleFieldsConfigList = pageModuleConfig?.[moduleHandle].configList;
    // 筛选
    const existFieldIDs = mainModuleFieldsConfigList?.filter((field: Record<string, any>) => (field.showSource || field.onlySaveData))
      .map((field: Record<string, any>) => (field.fieldID));
    columns = columns.filter((field: Record<string, any>) => (existFieldIDs?.includes(field.fieldID)));
    // 排序
    columns.sort((prevField: Record<string, any>, nextField: Record<string, any>) => {
      const prevFieldSort = mainModuleFieldsConfigList.findIndex((field: Record<string, any>) => {
        return field.fieldID === prevField.fieldID;
      });
      const nextFieldSort = mainModuleFieldsConfigList.findIndex((field: Record<string, any>) => {
        return field.fieldID === nextField.fieldID;
      });
      return prevFieldSort - nextFieldSort;
    });

    columns.map((col) => {
      const fieldOfConfig = mainModuleFieldsConfigList.find((field) => field.fieldID === col.fieldID);
      // 独占一行处理
      if (fieldOfConfig?.showOptions?.isSingleLine) {
        Object.assign(col, {
          colProps: { span: 24 },
        });
      }
      if (!fieldOfConfig?.showSource && fieldOfConfig?.onlySaveData) {
        Object.assign(col, {
          onlySaveData: true,
        });
      }
      // 自定义标题
      if (fieldOfConfig?.showOptions?.label) {
        Object.assign(col, {
          customLabel: fieldOfConfig?.showOptions?.label,
        });
      }
      if (fieldOfConfig?.isDisabled !== undefined) {
        Object.assign(col, {
          isDisabled: fieldOfConfig?.isDisabled,
        });
      }
      if (fieldOfConfig?.isRequired !== undefined) {
        Object.assign(col, {
          isRequired: fieldOfConfig?.isRequired,
        });
      }
    });
  }

  const mergeGroupData = pageModuleConfig?.[moduleHandle]?.groupField?.map((field, index) => {
    return {
      title: pageModuleConfig?.[moduleHandle]?.groupTitle[index] || '',
      values: field,
    };
  });

  // 以下代码不生效，因为没有走Field逻辑
  // columns?.forEach((field) => {
  //   field.getRowConfig = (record: any) => {
  //     return ruleMapMatchExec(
  //       rulesMap,
  //       [moduleHandle, field.dataIndex].join('.'),
  //       values,
  //     );
  //   };
  // });


  return {
    componentName: 'SPForm',
    title: pageModuleConfig?.[moduleHandle]?.tabName || resultModule?.name,
    tabNameShow: pageModuleConfig?.[moduleHandle]?.tabNameShow ?? true,
    submitBtnShow: pageModuleConfig?.[moduleHandle]?.submitBtnShow ?? true,
    props: {
      grid: true,
      colProps: { span: Math.floor(24 / (pageModuleConfig?.[moduleHandle]?.colNumber ?? 3)) },
      labelAlign: 'left',
      layout: pageModuleConfig?.[moduleHandle]?.formLayoutType,
      // labelCol: { span: 8 },
      // wrapperCol: { span: 20 },
      // labelWrap: true,
      submitter: false,
      isOpenGroup: pageModuleConfig?.[moduleHandle]?.isUseGroup,
      groupData: mergeGroupData,
      moduleID: moduleHandle,
      namespaceID: namespaceHandle,
      assetModuleInfo: resultModule,
      recordColumns: columns,
      mode: pageType !== 'view' ? 'edit' : 'read',
    },
    hidden: false,
    isLocked: false,
    condition: true,
    conditionGroup: '',
  };
};
